import { Dialog } from './dialog';

import type { DialogAdapterOptions } from './interfaces';

export type { DialogAdapterOptions };

export default Dialog;
